// Shared course-category progress aggregation, used by the student "My Courses"
// dashboard and the coach Syllabus Tracker so both compute progress identically.

export const COURSE_CATEGORIES = [
  { courseType: 'Computer Apps', icon: '💻', color: 'orange' },
  { courseType: 'Art', icon: '🎨', color: 'pink' },
  { courseType: 'Spoken English', icon: '🗣️', color: 'blue' },
  { courseType: 'Life Skills', icon: '🌟', color: 'green' },
];

// Aggregate a student's `courses` (as returned by the dashboard API) into
// totalTasks/completedTasks for one category. Computer Apps shows one card per
// course on its course page, so the dashboard card mirrors those visible cards
// instead of nested items.
export function aggregateCategoryProgress(courses = [], categoryType) {
  const categoryCourses = courses.filter((c) => c.courseType === categoryType);

  if (categoryType === 'Computer Apps') {
    return categoryCourses.reduce(
      (acc, curr) => ({
        totalTasks: acc.totalTasks + ((curr.totalTasks || 0) > 0 ? 1 : 0),
        completedTasks:
          acc.completedTasks + (curr.totalTasks > 0 && curr.completedTasks >= curr.totalTasks ? 1 : 0),
      }),
      { totalTasks: 0, completedTasks: 0 }
    );
  }

  return categoryCourses.reduce(
    (acc, curr) => ({
      totalTasks: acc.totalTasks + (curr.totalTasks || 0),
      completedTasks: acc.completedTasks + (curr.completedTasks || 0),
    }),
    { totalTasks: 0, completedTasks: 0 }
  );
}

// Returns COURSE_CATEGORIES enriched with { totalTasks, completedTasks } for the given courses.
export function getCourseProgressByCategory(courses = []) {
  return COURSE_CATEGORIES.map((category) => ({
    ...category,
    ...aggregateCategoryProgress(courses, category.courseType),
  }));
}
